import constants from '../../constants';
import './index_web.css';

const MatchMakingPlayerFoundWeb = ({ isLandscape }: any) => {
  return (
    <div className="matchMakingPlayerFound__container__web">
      <div
        className={`${
          isLandscape
            ? 'matchMakingPlayerFound__imgContainer__landscape'
            : 'matchMakingPlayerFound__imgContainer__web'
        }`}>
        <img
          className={
            isLandscape
              ? 'matchMakingPlayerFound__img__landscape'
              : 'matchMakingPlayerFound__img__web'
          }
          src={constants.Images.swords}
        />
        <span className="matchMakingPlayerFound__statusText__web" style={{ paddingTop: '25px' }}>
          Player Found
        </span>
      </div>
      <div
        className={`${
          isLandscape
            ? 'matchMakingPlayerFound__gameProgressText__landscape'
            : 'matchMakingPlayerFound__gameProgressText__web'
        }`}>
        Game Starts
      </div>
    </div>
  );
};

export default MatchMakingPlayerFoundWeb;
